import api from './api';
import { User, CreateUserData, UpdateUserData } from '../types/user';

export interface UserListResponse {
  success: boolean;
  data: User[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface UserResponse {
  success: boolean;
  data: User;
  message?: string;
}

export const userService = {
  async getUsers(params?: {
    page?: number;
    limit?: number;
    search?: string;
    role?: string;
    status?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
  }): Promise<UserListResponse> {
    const response = await api.get('/users', { params });
    return response.data;
  },

  async getUserById(id: number): Promise<UserResponse> {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  async createUser(data: CreateUserData): Promise<UserResponse> {
    const response = await api.post('/users', data);
    return response.data;
  },

  async updateUser(id: number, data: UpdateUserData): Promise<UserResponse> {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  async deleteUser(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  }
};